import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Breadcrumb from "../../components/Reusable/Breadcrumb";
import { Button } from "@mui/material";
import InfoBox from "../../components/Reusable/InfoBox";
import RewardDetail from "./RewardDetail";
import { fetchCatalogLevelList } from "../../actions/level";
import { useMemo } from "react";
import { useTranslation } from "react-i18next"; // Importuj useTranslation

const Reward = () => {
  const dispatch = useDispatch();

  const { t } = useTranslation(); // Koristi useTranslation za prevođenje

  const [showRewardDetail, setShowRewardDetail] = useState(false);
  const [rewardDetail, setRewardDetail] = useState(null);
  const [isEligible, setIsEligible] = useState(false);

  const { rewardList } = useSelector((state) => state.rewardReducer);
  const { levelCatalogList } = useSelector((state) => state.levelReducer);

  // const showLevelRewards = (level) => {
  //   setShowRewardDetail(false);
  //   dispatch(fetchRewardList(level.levelId));
  //   setIsEligible(level.isEligible);
  //   setActiveLevel(level.levelId);
  // };

  const setRewardDetailModel = (reward, levelIsEligible) => {
    if (levelIsEligible) {
      setRewardDetail(reward);
      setShowRewardDetail(true);
    }
  };

  const setShowRewardDetailClose = () => {
    setShowRewardDetail(false);
    setRewardDetail(null);
  };

  useEffect(() => {
    dispatch(fetchCatalogLevelList());
  }, [dispatch]);

  const levelsWithRewards = useMemo(() => {
    if (!levelCatalogList.length) {
      return [];
    }

    return levelCatalogList.map((level) => {
      const levelRewards = rewardList.length
        ? rewardList.filter((reward) => reward.levelId === level.levelId)
        : []; // Ako nema rewardList-a, rewards je prazan niz

      return {
        ...level,
        rewards: levelRewards,
      };
    });
  }, [levelCatalogList, rewardList]);

  return (
    <div className="reward-main-container">
      <Breadcrumb title={t("reward.breadcrumbTitle")} />

      <div className="level-list-container">
        <div className="level-list-items">
          {levelsWithRewards?.map((level, key) => (
            <div className="level-list-item">
              <div
                className={`level-list-item-title ${
                  level?.isEligible == true ? "active" : ""
                }`}
              >
                <img
                  src={level?.badge}
                  alt={level?.name}
                  className="badge-level-image-main"
                />{" "}
                <h4>{t(`level.${level?.name}`)}</h4>
              </div>
              <div className="level-list-item-rewards">
                <div className="reward-list-items-content">
                  {level?.rewards?.length === 0 && (
                    <InfoBox text={t("reward.noRewardsMessage")} />
                  )}

                  <div className="reward-content-list-items reward-list-items">
                    {level?.rewards?.map((reward) => {
                      return (
                        <div
                          className="reward-list-item"
                          onClick={() =>
                            setRewardDetailModel(reward, level?.isEligible)
                          }
                        >
                          <div className="reward-list-item-image">
                            {level?.isEligible === false && (
                              <div className="mask-lock-reward">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="27.578"
                                  height="36.771"
                                  viewBox="0 0 27.578 36.771"
                                >
                                  <path
                                    id="lock_15456524"
                                    d="M29.812,13.789h-2.3V10.725a10.725,10.725,0,0,0-21.45,0v3.064h-2.3A.766.766,0,0,0,3,14.555V33.707a3.064,3.064,0,0,0,3.064,3.064h21.45a3.064,3.064,0,0,0,3.064-3.064V14.555A.766.766,0,0,0,29.812,13.789ZM18.6,25.449l.49,4.351a.766.766,0,0,1-.766.843H15.257a.766.766,0,0,1-.766-.858l.49-4.351a3.054,3.054,0,1,1,3.616.015Zm4.321-11.659H10.661V10.725a6.128,6.128,0,0,1,12.257,0Z"
                                    transform="translate(-3)"
                                    fill="#fff"
                                    opacity="0.82"
                                  />
                                </svg>
                              </div>
                            )}
                            <img
                              src={`${reward.image}`}
                              className="img-fluid"
                              alt="LG OLED TV"
                            />
                          </div>
                          <div className="reward-list-item-body">
                            <div className="reward-list-item-title">
                              {reward.name}
                            </div>
                            <div className="reward-list-item-price">
                              {reward.points} {t("reward.pointsLabel")}
                            </div>
                            {level?.isEligible === true && (
                              <div className="reward-list-item-button">
                                <Button sx={{ textTransform: "none" }}>
                                  {t("reward.viewRewardButton")}
                                </Button>
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <RewardDetail
        showRewardDetail={showRewardDetail}
        rewardDetail={rewardDetail}
        setShowRewardDetail={setShowRewardDetailClose}
      />
    </div>
  );
};

export default Reward;
